/**
 * Enumeration of rights masks for resource permissions.
 * Uses bitwise flags for combining multiple rights.
 */
export enum RightsEnum {
  None = 0,
  Read = 1,
  Create = 2,
  Update = 4,
  Delete = 8,
  All = 255,
}
